import { render, staticRenderFns } from "./pindah_kelurahan_keseluruhan.vue?vue&type=template&id=4fd4a434&"
import script from "./pindah_kelurahan_keseluruhan.vue?vue&type=script&lang=js&"
export * from "./pindah_kelurahan_keseluruhan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports